import { cn } from "@/lib/utils";

// v6 card: whisper gradient, hairline, layered shadow, engraved top line. `quiet` = outline only, resting on the canvas.
export const Card = ({ as: Tag = "div", quiet = false, className, children, ...rest }) => (
  <Tag className={cn("rounded-card border border-os-border", quiet ? "bg-transparent" : "os-card", className)} {...rest}>
    {children}
  </Tag>
);
